<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="RentalProperty"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      schema="RentalProperty"
      :id="formId"
      class="container"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="property_unit"
        :label="'Real Property'|gettext"
      >
        <UcSiteSelector
          :item="item"
          path="property_unit"
        >
        </UcSiteSelector>
      </ItpFormGroup>
      <ItpFormGroup
        name="valid_from"
        :label="'Valid from'|gettext"
        class="w-auto"
      >
        <ItpFormDatetime
          type="date"
          name="valid_from"
          v-model="item.valid_from"
          :readonly="item.locked"
          :defaultValue="$fn.today()"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="valid_to"
        :label="'Valid to'|gettext"
        class="w-auto"
      >
        <ItpFormDatetime
          type="date"
          name="valid_to"
          v-model="item.valid_to"
          :readonly="item.locked"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="inactive"
      >
        <ItpFormCheckbox
          name="inactive"
          :label="'Inactive'|gettext"
          inline
          v-model="item.inactive"
          :readonly="item.locked"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <ItpFormGroup
        name="notes"
        :label="'Notes'|gettext"
      >
        <ItpFormTextarea
          name="notes"
          v-model="item.notes"
          :readonly="item.locked"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Lock'|gettext"
      variant="default"
      :spinning="actions.lock.isRunning"
      class="mr-auto"
      v-if="resourceId && !item.locked"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      :form="formId"
      :text="'Save'|gettext"
      type="submit"
      variant="primary"
      :spinning="actions.submit.isRunning"
      :disabled="!forms[formName] || !forms[formName].submittable"
      v-if="!item.locked"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_2186679009640457_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class RentalProperty extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  rentalId!: string;

  @Watch('rentalId')
  onRental_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("rentalId")
  }

  @Prop({
    type: String,
    default: null,
  })
  resourceId!: string;

  @Watch('resourceId')
  onResource_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("resourceId")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return this.resourceId
      ? this.$fn.fetch('read_rental_property', { parameters: { id: this.resourceId, rental_id: this.rentalId } })
      : this.$fn.schemaDefaults('CreateRentalProperty', { valid_from: this.$fn.today() })
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['item', 'formId', 'formName', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        formId: null,
        formName: "rentalProperyt",
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.resourceId ? this.$fn.gettext('Edit Rental Property') : this.$fn.gettext('Add Rental Property'),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_9578_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_9578, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_9584_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_9584, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_request_9582_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_9582, alias=submit
    return {
      operation: this.item.id ? 'update_rental_property' : 'create_rental_property',
      data: { ...this.item, rental_id: this.rentalId },
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_closeModal_9588_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1548630417156826_closeModal_9588, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1548630417156826_request_9586_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1548630417156826_request_9586, alias=lock
    return {
      operation: "update_rental_property",
      data: {
        id: this.item.id,
        rental_id: this.rentalId,
        locked: true,
        etag: this.item.etag
      },
    }
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2186679009640457_closeModal_9590_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_2186679009640457_closeModal_9590, alias=undefined
    return {
      name: this.modalName,
      result: {
        cancel: true,
      }
      ,
    }
  }

  async evh_2186679009640457_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_9578: actions.CloseModalAction;
    evh_7315092382398562_close_9577: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_9580: actions.CloseComponentAction;
    evh_2248226175642056_close_9579: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_9584: actions.CloseModalAction;
    evh_1040167445267876_success_9583: actions.EventHandlerImpl;
    act_1040167445267876_request_9582: actions.RequestAction;
    evh_1040167445267876_submit_9581: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1548630417156826_closeModal_9588: actions.CloseModalAction;
    evh_1548630417156826_success_9587: actions.EventHandlerImpl;
    act_1548630417156826_request_9586: actions.RequestAction;
    evh_1548630417156826_clickPreventStop_9585: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
    act_2186679009640457_closeModal_9590: actions.CloseModalAction;
    evh_2186679009640457_clickPreventStop_9589: actions.EventHandlerImpl;
    evh_2186679009640457_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_9578 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_9578_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_9577 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_9578,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_9577],
      }
    );
    const act_2248226175642056_closeComponent_9580 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_9579 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_9580,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_9579],
      }
    );
    const act_1040167445267876_closeModal_9584 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_9584_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_9583 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_9584,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_9582 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_9582_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_9583],
      }
    );
    const evh_1040167445267876_submit_9581 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_9582,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_9581],
      }
    );
    const act_1548630417156826_closeModal_9588 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1548630417156826_closeModal_9588_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_success_9587 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeModal_9588,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1548630417156826_request_9586 = new actions.RequestAction(
      {
        actionArgs: this.act_1548630417156826_request_9586_getActionArgs,
        displayName: "lock",
        events: [evh_1548630417156826_success_9587],
      }
    );
    const evh_1548630417156826_clickPreventStop_9585 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_request_9586,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_9585],
      }
    );
    const act_2186679009640457_closeModal_9590 = new actions.CloseModalAction(
      {
        actionArgs: this.act_2186679009640457_closeModal_9590_getActionArgs,
        events: [],
      }
    );
    const evh_2186679009640457_clickPreventStop_9589 = new actions.EventHandlerImpl(
      {
        action: act_2186679009640457_closeModal_9590,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_2186679009640457_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2186679009640457_clickPreventStop_9589],
      }
    );
    return {
      act_7315092382398562_closeModal_9578,
      evh_7315092382398562_close_9577,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_9580,
      evh_2248226175642056_close_9579,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_9584,
      evh_1040167445267876_success_9583,
      act_1040167445267876_request_9582,
      evh_1040167445267876_submit_9581,
      evh_1040167445267876_submit,
      act_1548630417156826_closeModal_9588,
      evh_1548630417156826_success_9587,
      act_1548630417156826_request_9586,
      evh_1548630417156826_clickPreventStop_9585,
      evh_1548630417156826_clickPreventStop,
      act_2186679009640457_closeModal_9590,
      evh_2186679009640457_clickPreventStop_9589,
      evh_2186679009640457_clickPreventStop,
      submit: act_1040167445267876_request_9582,
      lock: act_1548630417156826_request_9586,
    }
  }
}

Vue.component("RentalProperty", RentalProperty);

</script>